import { isValidStatus } from '../../containers/ActForm/constants';

const statusValidation = (activity) => (isValidStatus(activity.status) ? {} : { status: 'Le statut est invalide' });

export default statusValidation;
